export default "__VITE_ASSET__DKriE5Ub__"